import { render, staticRenderFns } from "./abroad-souyu.vue?vue&type=template&id=468fcb5f&"
import script from "./abroad-souyu.vue?vue&type=script&lang=js&"
export * from "./abroad-souyu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports